(function () {
  const GIFT_VARIANT_ID = 47831004578094;
  const MINIMUM_AMOUNT = 6999; // €69,99 in centesimi
  const REQUIRED_TAG = 'TENNIS SS26';

  async function getCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  async function getProductTags(handle) {
    const res = await fetch(`/products/${handle}.js`);
    const data = await res.json();
    return data.tags || [];
  }

  async function calculateEligibleAmount(items) {
    let total = 0;
    for (const item of items) {
      if (item.variant_id === GIFT_VARIANT_ID) continue;
      const tags = await getProductTags(item.handle);
      if (tags.includes(REQUIRED_TAG)) {
        total += item.final_line_price;
      }
    }
    return total;
  }

  async function addGift() {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: GIFT_VARIANT_ID,
        quantity: 1,
        properties: { _gift: 'true' }
      }),
    });
  }

  async function removeGift(lineKey) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 0 }),
    });
  }

  async function refreshCart() {
    // Impact 6.x — aggiorna il drawer via sezioni
    try {
      const res = await fetch('/?sections=cart-drawer');
      const data = await res.json();
      if (data['cart-drawer']) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data['cart-drawer'], 'text/html');
        const newInner = doc.querySelector('#shopify-section-cart-drawer');
        const existing = document.querySelector('#shopify-section-cart-drawer');
        if (existing && newInner) existing.innerHTML = newInner.innerHTML;
      }
    } catch (e) {}

    document.dispatchEvent(new CustomEvent('theme:cart:change'));
    document.dispatchEvent(new CustomEvent('cart:refresh'));

    // Fallback pagina /cart
    if (window.location.pathname === '/cart') window.location.reload();
  }

  async function checkFreeGift() {
    const cart = await getCart();
    const eligibleAmount = await calculateEligibleAmount(cart.items);
    const qualifies = eligibleAmount >= MINIMUM_AMOUNT;
    const giftItem = cart.items.find(i => i.variant_id === GIFT_VARIANT_ID);

    if (qualifies && !giftItem) {
      await addGift();
      await refreshCart();
    }

    if (!qualifies && giftItem) {
      await removeGift(giftItem.key);
      await refreshCart();
    }
  }

  // Intercetta chiamate carrello
  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const result = await originalFetch(...args);
    const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url || '');

    if (
      url.includes('/cart/add') ||
      url.includes('/cart/change') ||
      url.includes('/cart/update')
    ) {
      result.clone().json().then(() => {
        setTimeout(checkFreeGift, 500);
      }).catch(() => {});
    }

    return result;
  };

  document.addEventListener('DOMContentLoaded', checkFreeGift);
})();